import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-confirmation-modal',
  templateUrl: './generic-confirmation-modal.component.html',
  styleUrls: ['./generic-confirmation-modal.component.css'],
})
export class GenericConfirmationModalComponent {
  formattedData: string;

  constructor(public dialogRef: MatDialogRef<GenericConfirmationModalComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {
    this.formattedData = data.replace(/\n/g, '<br />');
  }
}
